/**
 * FuelBox — Inline Product Cards for Blog Articles
 * Finds [data-fb-product] placeholders and loads product cards
 * via Shopify Section Rendering API.
 */
(function () {
  'use strict';

  var SECTION_ID = 'inline-product-card';

  document.addEventListener('DOMContentLoaded', function () {
    var placeholders = document.querySelectorAll('[data-fb-product]');
    if (!placeholders.length) return;

    placeholders.forEach(function (el) {
      var handle = el.getAttribute('data-fb-product');
      if (!handle) {
        el.remove();
        return;
      }

      fetch('/products/' + encodeURIComponent(handle) + '?section_id=' + SECTION_ID)
        .then(function (res) {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var section = doc.getElementById('shopify-section-' + SECTION_ID);

          if (!section || !section.innerHTML.trim()) {
            el.remove();
            return;
          }

          el.removeAttribute('data-fb-product');
          el.innerHTML = section.innerHTML;
        })
        .catch(function () {
          el.remove();
        });
    });
  });
})();
